import {
    DefaultPriceBadge,
    LabelsBadges,
    LastModifiedBadge,
    TaxabilityBadge,
} from "@molecules/ObjectCard/Attributes/AttributeBadges"
import ObjectCard from "@molecules/ObjectCard/ObjectCard"
import { shouldShowAttribute } from "@molecules/ObjectCard/ObjectCards/ObjectCards.utils"
import { PriceBookItemSubcardProps } from "@molecules/ObjectCard/ObjectCards/PriceBookItemCard/PriceBookItemCard.types"
import ObjectStatusBadge from "@molecules/ObjectStatusBadge/ObjectStatusBadge"

export default function OtherCard(props: PriceBookItemSubcardProps) {
    const { pricebookItem, displayedAttributes, onClick, isLoading = false, className, ...errorProps } = props

    // The price is always shown when selected, even at $0.00.
    const showPrice = shouldShowAttribute(displayedAttributes, "default_price")
    const showTaxability = shouldShowAttribute(displayedAttributes, "default_is_taxable")
    const showLastModified =
        shouldShowAttribute(displayedAttributes, "last_modified_at") && Boolean(pricebookItem.last_modified_at)
    const showLabels = shouldShowAttribute(displayedAttributes, "labels") && pricebookItem.labels.length > 0

    const hasAttributes = showPrice || showTaxability || showLastModified || showLabels

    return (
        <ObjectCard onClick={onClick} isLoading={isLoading} className={className} {...errorProps}>
            <ObjectCard.Header
                id="Other"
                subId={pricebookItem.subtype_label || undefined}
                subIdLabel="Subtype"
                statusBadge={
                    <ObjectStatusBadge objectType="pricebook_item" status={pricebookItem.status_label} size="md" />
                }
            />
            <ObjectCard.Body
                primaryText={pricebookItem.description}
                secondaryText={pricebookItem.summary_template || undefined}
            />
            {(isLoading || hasAttributes) && (
                <ObjectCard.Attributes>
                    {showPrice && <DefaultPriceBadge value={pricebookItem.default_price} label="Default unit price" />}
                    {showTaxability && <TaxabilityBadge isTaxable={pricebookItem.default_is_taxable} />}
                    {showLastModified && <LastModifiedBadge date={pricebookItem.last_modified_at} />}
                    {showLabels && <LabelsBadges labels={pricebookItem.labels} />}
                </ObjectCard.Attributes>
            )}
        </ObjectCard>
    )
}
